import { LogoUploader } from '../LogoUploader';
import { CandidateExperienceDefaultsForm } from '../CandidateExperienceDefaultsForm';

interface BrandingLogoCardProps {
  logoUrl: string | null;
  logoPublicId: string | null;
  onUpload: (file: File) => void;
  onRemove: () => void;
  isLogoPending: boolean;
  showOrgLogo: boolean;
  onToggleShowOrgLogo: (next: boolean) => void;
  isDefaultsPending: boolean;
}

export function BrandingLogoCard({
  logoUrl,
  logoPublicId,
  onUpload,
  onRemove,
  isLogoPending,
  showOrgLogo,
  onToggleShowOrgLogo,
  isDefaultsPending,
}: BrandingLogoCardProps) {
  return (
    <section className="overflow-hidden rounded-xl border border-border bg-card">
      <div className="flex flex-col gap-3 border-b border-border px-5 py-4 sm:flex-row sm:items-start sm:justify-between sm:gap-4 sm:px-6 sm:py-5">
        <div>
          <h2 className="font-display text-[19px] font-medium leading-tight tracking-tight text-foreground">
            Logo
          </h2>
          <p className="mt-1 max-w-prose text-[13px] leading-relaxed text-muted-foreground">
            Shown to candidates during conversations. A PNG or WebP with a transparent background
            looks best.
          </p>
        </div>
        <div className="shrink-0 sm:pt-0.5">
          <CandidateExperienceDefaultsForm
            showOrgLogo={showOrgLogo}
            onToggleShowOrgLogo={onToggleShowOrgLogo}
            isPending={isDefaultsPending}
          />
        </div>
      </div>
      <div className="p-5 sm:p-6">
        <LogoUploader
          logoUrl={logoUrl}
          logoPublicId={logoPublicId}
          onUpload={onUpload}
          onRemove={onRemove}
          isPending={isLogoPending}
          shown={showOrgLogo}
        />
      </div>
    </section>
  );
}
